import { Component, OnInit, NgZone, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { LocationService } from '../../Services/location.service';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { VERBIAGE } from 'src/app/config';
import { RBLocation } from '../../Models/Location';

@Component({
    selector: 'location-edit',
    templateUrl: './location-edit.component.html',
    styleUrls: ['./location-edit.component.scss']
})

export class LocationEditComponent implements OnInit, OnDestroy {
    Location: RBLocation; regions: RBLocation[];
    showMap: boolean = false;
    sameRegionError: boolean = false;

    LocationType: string;

    // Set input masks for form controls
    inputMask = { phone: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] };

    constructor(
        private _shared: SharedService,private _location: LocationService, private _zone: NgZone,
        private _notify: NotificationService, private _router: Router, private _route: ActivatedRoute
    ) {
        // Show loader
        this._shared.loadingState = true;
    }

    async ngOnInit() {
        // Get location detail
        const locationID = +this._route.snapshot.params.id;
        this.Location = <RBLocation>await this._location.getLocationById(locationID);

        this.LocationType = this.Location.isRegional;
        // Setting up padge title
        this._shared.pageTitle = this.Location.locationName;
        this.animateMap();

        // Get regions of country
        this._location.getRegions().subscribe(res => this.regions = res['result']);

        // Adding page controls
        const _this = this;
        this._shared.pageControls = [
            { type: '-icon-', title: 'Previous page', icon: 'arrow_back', action() {
                _this._router.navigate([(_this._shared.getPreviousUrl !== _this._router.url) ? _this._shared.getPreviousUrl : '/dashboard/locations']);
            }}
        ];

        // Hide loader
        this._shared.loadingState = false;
    }

    getAddress(address) {
        // Google places autocomplete.
        this._zone.run(() => {
            // Mapping address_1            
            if (address.street_number && address.route) {
                address['regional_address_1'] = address.street_number + ' ' + address.route;
            } else if (address.street_number && address.route === undefined) {
                address['regional_address_1'] = address.street_number;
            } else if (address.street_number === undefined && address.route) {
                address['regional_address_1'] = address.route;
            }

            // Mapping address_2
            if (address.neighborhood) {
                address['regional_address_2'] = address.neighborhood;
            }

            Object.keys(address).forEach(val => {
                this.Location[val] = address[val]
            });

            this.animateMap();
        });
    }


    checkRegionName(regionName: string, form) {
        let region = this.regions.filter(r => r.regionName.toLowerCase() === regionName.trim().toLowerCase()).shift();
        if (region) {
            this.sameRegionError = true;
            form.controls['regionName'].setErrors({ 'incorrect': true });
        } else {
            this.sameRegionError = false;
        }
    }

    reverseGeocode(e) {
        // Reverse geocoding can be added please look places-autocomplete derective.
        this.Location.lat = e.coords.lat; this.Location.lng = e.coords.lng;
    }

    updateLocation(form) {
        if (form.valid) {
            // Update location in DB
            this._location.updateLocation(form.value).subscribe(res => {
                if (res['status'] === 'OK') {
                    this._notify.toastMessage({
                        color: 'accent', message: VERBIAGE.SERVICE_CENTER_UPDATE_SUCCESS, duration: 3000
                    });
                    this._router.navigate(['/dashboard/locations']);
                }
            }, err => this._notify.toastMessage({ color: 'warn', message: VERBIAGE.SERVICE_CENTER_UPDATE_FAIL, duration: 3000 }))
            return;
        }

        this._notify.toastMessage({ color: 'warn', message: VERBIAGE.SERVICE_CENTER_FORM_ERROR, duration: 3000 })
    }

    animateMap() {
        this.Location['zoom'] = 0;
        // Animate map
        let interval = setInterval(() => {
            this.Location['zoom'] += 0.5;
            if (this.Location['zoom'] === 16) { clearInterval(interval); }
        }, 100);
    }

    ngOnDestroy() {
        // Removing page controls
        this._shared.pageControls = null;
    }
}